import { emptyAddress, formatNumber, formatNumberDecimals } from '../../../common';
import { exchangeRates } from '../data/global';

export const convertToUSD = (amount: any, pretty = false, tokenAddress = emptyAddress): string => {
  if (!exchangeRates.value[tokenAddress]) return null;
  const convertedAmount = Number(amount) * exchangeRates.value[tokenAddress];
  return pretty
     ? formatNumber(convertedAmount)
     : formatNumberDecimals(convertedAmount);
};
